import script from "./HomeLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeLayout.vue?vue&type=script&setup=true&lang=js"

import "./HomeLayout.vue?vue&type=style&index=0&id=3fb9d96c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb9d96c"]])

export default __exports__